"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("util");
var utils_1 = require("./utils");
var BULK_WRITE_ENDPOINT = 0x02;
var BULK_READ_ENDPOINT = 0x81;
exports.DevicesIds = [
    { vendorId: 0x04dd, deviceId: 0x7202, name: 'Sharp IM-MT899H' },
    { vendorId: 0x04dd, deviceId: 0x9013, name: 'Sharp IM-DR400' },
    { vendorId: 0x04dd, deviceId: 0x9014, name: 'Sharp IM-DR80' },
    { vendorId: 0x054c, deviceId: 0x0034, name: 'Sony PCLK-XX' },
    { vendorId: 0x054c, deviceId: 0x0036, name: 'Sony' },
    { vendorId: 0x054c, deviceId: 0x0075, name: 'Sony MZ-N1' },
    { vendorId: 0x054c, deviceId: 0x007c, name: 'Sony' },
    { vendorId: 0x054c, deviceId: 0x0080, name: 'Sony LAM-1' },
    { vendorId: 0x054c, deviceId: 0x0081, name: 'Sony MDS-JB980' },
    { vendorId: 0x054c, deviceId: 0x0084, name: 'Sony MZ-N505' },
    { vendorId: 0x054c, deviceId: 0x0085, name: 'Sony MZ-S1' },
    { vendorId: 0x054c, deviceId: 0x0086, name: 'Sony MZ-N707' },
    { vendorId: 0x054c, deviceId: 0x008e, name: 'Sony CMT-C7NT' },
    { vendorId: 0x054c, deviceId: 0x0097, name: 'Sony PCGA-MDN1' },
    { vendorId: 0x054c, deviceId: 0x00ad, name: 'Sony CMT-L7HD' },
    { vendorId: 0x054c, deviceId: 0x00c6, name: 'Sony MZ-N10' },
    { vendorId: 0x054c, deviceId: 0x00c7, name: 'Sony MZ-N910' },
    { vendorId: 0x054c, deviceId: 0x00c8, name: 'Sony MZ-N710/NF810' },
    { vendorId: 0x054c, deviceId: 0x00c9, name: 'Sony MZ-N510/N610' },
    { vendorId: 0x054c, deviceId: 0x00ca, name: 'Sony MZ-NE410/NF520D' },
    { vendorId: 0x054c, deviceId: 0x00eb, name: 'Sony MZ-NE810/NE910' },
    { vendorId: 0x054c, deviceId: 0x0101, name: 'Sony LAM-10' },
    { vendorId: 0x054c, deviceId: 0x0113, name: 'Aiwa AM-NX1' },
    { vendorId: 0x054c, deviceId: 0x013f, name: 'Sony MDS-S500' },
    { vendorId: 0x054c, deviceId: 0x014c, name: 'Aiwa AM-NX9' },
    { vendorId: 0x054c, deviceId: 0x017e, name: 'Sony MZ-NH1' },
    { vendorId: 0x054c, deviceId: 0x0180, name: 'Sony MZ-NH3D' },
    { vendorId: 0x054c, deviceId: 0x0182, name: 'Sony MZ-NH900' },
    { vendorId: 0x054c, deviceId: 0x0184, name: 'Sony MZ-NH700/NH800' },
    { vendorId: 0x054c, deviceId: 0x0186, name: 'Sony MZ-NH600' },
    { vendorId: 0x054c, deviceId: 0x0187, name: 'Sony MZ-NH600D' },
    { vendorId: 0x054c, deviceId: 0x0188, name: 'Sony MZ-N920' },
    { vendorId: 0x054c, deviceId: 0x018a, name: 'Sony LAM-3' },
    { vendorId: 0x054c, deviceId: 0x01e9, name: 'Sony MZ-DH10P' },
    { vendorId: 0x054c, deviceId: 0x0219, name: 'Sony MZ-RH10' },
    { vendorId: 0x054c, deviceId: 0x021b, name: 'Sony MZ-RH710/MZ-RH910' },
    { vendorId: 0x054c, deviceId: 0x021d, name: 'Sony CMT-AH10' },
    { vendorId: 0x054c, deviceId: 0x022c, name: 'Sony CMT-AH10' },
    { vendorId: 0x054c, deviceId: 0x023c, name: 'Sony DS-HMD1' },
    { vendorId: 0x054c, deviceId: 0x0286, name: 'Sony MZ-RH1' },
    { vendorId: 0x0b28, deviceId: 0x1004, name: 'Kenwood MDX-J9' },
];
var NetMD = /** @class */ (function () {
    function NetMD(device, iface, logger) {
        if (iface === void 0) { iface = 0; }
        var _a;
        this.device = device;
        this.iface = iface;
        this.logger = logger;
        this.logger = (_a = logger) === null || _a === void 0 ? void 0 : _a.child({ class: 'NetMD' });
    }
    NetMD.prototype.init = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var len;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('Init');
                        if (!!this.device.opened) return [3 /*break*/, 2];
                        (_b = this.logger) === null || _b === void 0 ? void 0 : _b.debug('Opening device');
                        return [4 /*yield*/, this.device.open()];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.device.selectConfiguration(1)];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, this.device.claimInterface(this.iface)];
                    case 4:
                        _c.sent();
                        return [4 /*yield*/, this.getReplyLength()];
                    case 5:
                        len = (_c.sent()).len;
                        if (!(len > 0)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.readReply()];
                    case 6:
                        _c.sent();
                        _c.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    NetMD.prototype.getDeviceName = function () {
        var _a, _b;
        var _c = this.device, vendorId = _c.vendorId, productId = _c.productId;
        var deviceId = exports.DevicesIds.find(function (device) { return device.deviceId === productId && device.vendorId === vendorId; });
        return _b = (_a = deviceId) === null || _a === void 0 ? void 0 : _a.name, (_b !== null && _b !== void 0 ? _b : 'Unknown Device');
    };
    NetMD.prototype.finalize = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug('Finalize');
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.device.reset()];
                    case 2:
                        _c.sent();
                        return [4 /*yield*/, this.device.releaseInterface(this.iface)];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, this.device.close()];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _c.sent();
                        (_b = this.logger) === null || _b === void 0 ? void 0 : _b.error({ err: err_1 });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    NetMD.prototype.getReplyLength = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var result, len;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.device.controlTransferIn({
                            requestType: 'vendor',
                            recipient: 'interface',
                            request: 0x01,
                            value: 0,
                            index: 0,
                        }, 4)];
                    case 1:
                        result = _d.sent();
                        len = (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.getUint8(2), (_b !== null && _b !== void 0 ? _b : 0));
                        (_c = this.logger) === null || _c === void 0 ? void 0 : _c.debug({ action: 'getReplyLength', result: util_1.inspect(result), len: len });
                        return [2 /*return*/, { len: len, data: result.data }];
                }
            });
        });
    };
    NetMD.prototype.sendCommand = function (command) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug({ action: 'sendCommand', command: util_1.inspect(command) });
                        return [4 /*yield*/, this.device.controlTransferOut({
                                requestType: 'vendor',
                                recipient: 'interface',
                                request: 0x80,
                                value: 0,
                                index: 0,
                            }, command)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMD.prototype.readReply = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var len, i, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getReplyLength()];
                    case 1:
                        len = (_b.sent()).len;
                        i = 0;
                        _b.label = 2;
                    case 2:
                        if (!(len === 0)) return [3 /*break*/, 5];
                        return [4 /*yield*/, utils_1.sleep(NetMD.readReplyRetryIntervalInMsec * Math.pow(2, ~~(i / 10)))];
                    case 3:
                        _b.sent(); // Double wait time every 10 attempts
                        return [4 /*yield*/, this.getReplyLength()];
                    case 4:
                        (len = (_b.sent()).len);
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [4 /*yield*/, this.device.controlTransferIn({
                            requestType: 'vendor',
                            recipient: 'interface',
                            request: 0x81,
                            value: 0,
                            index: 0,
                        }, len)];
                    case 6:
                        result = _b.sent();
                        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug({ action: 'readReply', result: util_1.inspect(result) });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    NetMD.prototype.readBulk = function (length) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readBulkToArray(length)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, new Uint8Array(result)];
                }
            });
        });
    };
    NetMD.prototype.readBulkToArray = function (length, chunksize) {
        if (chunksize === void 0) { chunksize = 0x10000; }
        return __awaiter(this, void 0, void 0, function () {
            var done, buffer, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        done = 0;
                        buffer = new ArrayBuffer(0);
                        _a.label = 1;
                    case 1:
                        if (!(done < length)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.device.transferIn(this.iface, Math.min(length - done, length))];
                    case 2:
                        res = _a.sent();
                        if (!res.data) {
                            throw new Error('expected data');
                        }
                        done += res.data.byteLength; // TODO: handle this case
                        buffer = utils_1.concatArrayBuffers(buffer, res.data.buffer);
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, buffer];
                }
            });
        });
    };
    NetMD.prototype.writeBulk = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.device.transferOut(BULK_WRITE_ENDPOINT, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NetMD.readReplyRetryIntervalInMsec = 10;
    return NetMD;
}());
exports.NetMD = NetMD;
//# sourceMappingURL=netmd.js.map